import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=3af099ea&"
import script from "./todo.vue?vue&type=script&lang=ts&"
export * from "./todo.vue?vue&type=script&lang=ts&"
import style0 from "./todo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports